<template>
<div class="l-acordion">
  <div :class="['l-acordion__header', isOpen ? '--selected' : '']" @click="handleAccordion">
    <Img v-if="type === 'qa'" class="l-acordion__header-icon" src="/assets/img/ic_question.png"></Img>
    <Text className="c-text--bold" :text="headText"></Text>
  </div>
  <div :class="['l-acordion__body', isOpen ? '--selected' : '']">
    <Text className="c-text--bold" :text="bodyText"></Text>
  </div>
</div>
</template>

<script>
import Text from '@/components/atoms/Text.vue'
import Img from '@/components/atoms/Img.vue'

export default {
  components: {
    Text,
    Img
  },
  props: {
    type: String,
    headText: String,
    bodyText: String
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    handleAccordion () {
      this.isOpen ? this.isOpen = false : this.isOpen = true
    }
  }
}
</script>

<style lang="scss" scoped>
.l-acordion {
  width: 100%;
  margin-top: 20px;
  white-space: pre-wrap;
  &__header {
   width: 100%;
   padding: 10px 20px 10px 10px;
   background: #fff;
   border-radius: 50px;
   box-sizing: border-box;
   box-shadow: $bs_default;
   display: flex;
   align-items: center;
   transition-duration: 0.3s;
   &:hover {
     box-shadow: $bs_learge;
     cursor: pointer;
   }
   &.--selected {
    background: $color_gray_light;
   }
   &-icon {
     width: 40px;
     height: 40px;
     margin-right: 10px;
   }
  }
  &__body {
    width: calc(100% - 20px);
    height: 0;
    margin: 0 auto;
    padding: 0 20px;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: $bs_default;
    opacity: 0;
    transition-duration: 0.3s;
    > * {
      display: none;
    }
    &.--selected {
      height: auto;
      margin: 10px auto 30px;
      padding: 20px;
      opacity: 1;
      > * {
        display: block;
      }
    }
  }
}
</style>
